import { useTranslation } from 'react-i18next'

export interface LoginBrandPanelProps {
  /** Visibility/layout classes owned by the caller (min-height, safe-area, etc.). */
  className?: string
}

/**
 * Login hero panel (EP-109; desktop artwork refreshed 2026-09-07 from Figma
 * Login-lg 548:3822). Desktop renders the exported brand composition (logo +
 * Thai headline + device mockups) as a single cover image on the dark brand
 * ground; the headline is baked into that artwork, so the live (i18n) headline
 * renders only below lg. Mobile is unchanged: a transparent panel carrying the
 * live headline over the collage backdrop LoginPage pins behind the status-bar
 * strip (iOS Safari edge-to-edge fix). Purely presentational.
 */
export function LoginBrandPanel({ className = '' }: LoginBrandPanelProps) {
  const { t } = useTranslation('auth')

  return (
    <div
      className={`${className} relative overflow-hidden flex-col items-center justify-center text-center px-8 py-8 lg:py-12 lg:bg-[#04201e]`}
    >
      {/* Desktop-only brand artwork (Figma 548:3914 exported at 2x, webp). */}
      <img
        src="/images/login-hero.webp"
        alt=""
        aria-hidden="true"
        className="hidden lg:block pointer-events-none absolute inset-0 h-full w-full object-cover object-top"
      />
      {/* Mobile keeps the live localized headline (desktop bakes it into the image). */}
      <h2 className="lg:hidden relative text-3xl font-bold text-primary-content leading-snug max-w-md drop-shadow-sm">
        {t('login.brand.headline')}
      </h2>
    </div>
  )
}

LoginBrandPanel.displayName = 'LoginBrandPanel'
